import { render, staticRenderFns } from "./TeacherView.vue?vue&type=template&id=0ed73a26&scoped=true"
import script from "./TeacherView.vue?vue&type=script&lang=js"
export * from "./TeacherView.vue?vue&type=script&lang=js"
import style0 from "./TeacherView.vue?vue&type=style&index=0&id=0ed73a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed73a26",
  null
  
)

export default component.exports